import type { ReactNode } from "react";

import DashboardSection from "./sections/DashboardSection";
import JournalSection from "./sections/JournalSection";
import TimeEntriesSection from "./sections/TimeEntriesSection";
import IdentitySection from "./sections/IdentitySection";
import RepositoriesSection from "./sections/RepositoriesSection";
import ClientsSection from "./sections/ClientsSection";
import ReportsSection from "./sections/ReportsSection";
import ReleasesSection from "./sections/ReleasesSection";
import OwnersOnly from "./components/OwnersOnly";

// ---------------------------------------------------------------------------
// Navegación de la app "Horas Trabajadas" (#528). Alimenta el sub-menú
// (WorkHoursLayout) y las rutas (routes.tsx). Clientes y Reportes son SOLO de
// los dueños (#1064): no salen en el menú de nadie más, la API responde 403 y,
// si alguien llega por la URL, `OwnersOnly` lo explica en vez de la sección.
// ---------------------------------------------------------------------------

export interface WorkHoursNavItem {
  id: string;
  labelKey: string;
  icon: string;
  element: ReactNode;
  /** Solo dueños (#1064): oculta del menú y protegida con `OwnersOnly`. */
  ownersOnly?: boolean;
}

export const MENU: WorkHoursNavItem[] = [
  { id: "dashboard", labelKey: "workHours.menu.dashboard", icon: "ri-fire-line", element: <DashboardSection /> },
  // Entradas de tiempo en minutos por día (#783): lo que se paga y factura.
  { id: "time-entries", labelKey: "workHours.menu.timeEntries", icon: "ri-timer-line", element: <TimeEntriesSection /> },
  { id: "journal", labelKey: "workHours.menu.journal", icon: "ri-book-open-line", element: <JournalSection /> },
  { id: "identity", labelKey: "workHours.menu.identity", icon: "ri-github-line", element: <IdentitySection /> },
  { id: "repositories", labelKey: "workHours.menu.repositories", icon: "ri-git-repository-line", element: <RepositoriesSection /> },
  {
    id: "clients",
    labelKey: "workHours.menu.clients",
    icon: "ri-briefcase-4-line",
    ownersOnly: true,
    element: (
      <OwnersOnly>
        <ClientsSection />
      </OwnersOnly>
    ),
  },
  {
    id: "reports",
    labelKey: "workHours.menu.reports",
    icon: "ri-mail-send-line",
    ownersOnly: true,
    element: (
      <OwnersOnly>
        <ReportsSection />
      </OwnersOnly>
    ),
  },
  // Releases y despliegues (#998): versión de QA y prod por plataforma, métricas.
  { id: "releases", labelKey: "workHours.menu.releases", icon: "ri-rocket-2-line", element: <ReleasesSection /> },
];

/** Secciones del menú para quien es (o no) dueño. Mientras no se sabe, sin las de dueños. */
export const menuFor = (isOwner: boolean): WorkHoursNavItem[] => MENU.filter((item) => isOwner || !item.ownersOnly);

export const WORK_HOURS_BASE = "/work-hours";

export const workHoursDefaultRoute = `${WORK_HOURS_BASE}/${MENU[0].id}`;
